class PdpBundle extends HTMLElement {
    constructor() {
        super()
        this.selectors = {
            pdpBundleContainer      : '[js-pdp-bundle-container]',
            bundleProductWrapper    : '[js-bundle-product-element]',
            productIdInput          : '[js-product-id-input]',
            
        }
        this.addEventListener('click', function() {
            this.handleClick()
        })

        
    }

    handleClick() {
        const currentProduct = this.querySelector(this.selectors.bundleProductWrapper)
        const currentInput   = this.querySelector(this.selectors.productIdInput)
        const currentId = this.dataset.productId
        if(!currentProduct.classList.contains('active')) {
            currentProduct.classList.add('active')
            currentInput.value = currentId
        } else {
            currentProduct.classList.remove('active')
            currentInput.value=''
        }

        // check if any product is selected or not
        document.dispatchEvent(new CustomEvent('checkProductsSelection'))
        // update price according to product selection
        document.dispatchEvent(new CustomEvent('updateBundleTotalPrice'))

    }
    
}

customElements.define('pdp-bundle', PdpBundle)

document.addEventListener('DOMContentLoaded', function() {
    function pdpBundleATC() {

        const selectors = {
            container               : '[js-pdp-bundle-container]',
            pdpBundleATC            : '[js-pdp-bundle-atc]',
            bundleProducts          : '[js-bundle-product-element]',
            atcButton               : `[js-pdp-bundle-atc] button`,
            bundleItems             : 'pdp-bundle'
        }
        const container = document.querySelector(selectors.container)
        const submitButton = container.querySelector(selectors.atcButton)
        const bundleProducts = Array.from(container.querySelectorAll(selectors.bundleProducts))
        const bundleItems = container.querySelectorAll(selectors.bundleItems)
        const storeCurrency = container.dataset.storeCurrency
    
    
        let totalPrice=0
        let comparePrice=0
        // button wrapper
        const submitButton_ = document.querySelector(selectors.pdpBundleATC)
    
        submitButton_.addEventListener('click', addToCart_)
    
        function getFirstBundleProdcutSelected() {
            bundleProducts[0].click()
        }
    
        getFirstBundleProdcutSelected()
        document.addEventListener('selectFirstBundleProduct', getFirstBundleProdcutSelected)
        function getPriceUpdate() {
            totalPrice = 0
            comparePrice=0

            let ComparePriceAvailable = bundleProducts.find(item => {
                if(item.classList.contains('active') && item.dataset.productComparePrice != undefined && Number(item.dataset.productComparePrice) > Number(item.dataset.productPrice)) { 
                     return true;
                }
            })
          
            bundleProducts.forEach(item => {
                if(item.classList.contains('active')) {
                    totalPrice += Number(item.dataset.productPrice)
                    if(ComparePriceAvailable) {
                       if(item.dataset.productComparePrice != undefined && Number(item.dataset.productComparePrice) > Number(item.dataset.productPrice)) { 
                          comparePrice += Number(item.dataset.productComparePrice)
                       }
                       else {
                           comparePrice += Number(item.dataset.productPrice)
                       }
                    }
                }
            })




          
         //  let discountPercentage = 0;
         //  let qtySelects = document.querySelector('product-qty');
         //  if(qtySelects) {
         //      let selectedOption = Array.from(qtySelects.querySelectorAll('fieldset'), (element) => {
         //        if (element.tagName === 'FIELDSET') {
         //          return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked);
         //        }
         //      });
         //      if(selectedOption != undefined) {
         //        discountPercentage = selectedOption[0].getAttribute('data-percentage-off');
         //      }
         //  }

         //  console.log('totalPrice', totalPrice, discountPercentage);
         //  if(discountPercentage > 0 && totalPrice > 0) {
         //      totalPrice = ((100-discountPercentage)*totalPrice)/100;
         //      comparePrice = 0;
         //       bundleProducts.forEach(item => {
         //        if(item.classList.contains('active')) {
         //            comparePrice += Number(item.dataset.productPrice);
         //        }
         //       });
         //  }
         // console.log('discountedtotalPrice', totalPrice, comparePrice);

          let discountPercentage = 0;
          let lengthOfProducts = 0;
          bundleProducts.forEach(item => {
            if(item.classList.contains('active')) {
              lengthOfProducts = lengthOfProducts + 1;
            }
          });
         
          if(lengthOfProducts == 2) {
             discountPercentage = 10;
          }
          else if(lengthOfProducts == 3) {
             discountPercentage = 20;
          }
          else if(lengthOfProducts == 4) {
             discountPercentage = 30;
          }
          if(discountPercentage > 0 && totalPrice > 0) {
              totalPrice = ((100-discountPercentage)*totalPrice)/100;
              comparePrice = 0;
               bundleProducts.forEach(item => {
                if(item.classList.contains('active')) {
                    comparePrice += Number(item.dataset.productPrice);
                }
               });
          }
         //console.log('discountedtotalPrice', totalPrice, comparePrice);

          
         submitButton.querySelector('[js-bundle-total-price]').textContent = storeCurrency + parseFloat(totalPrice).toFixed(2)

            if(submitButton.querySelector('[js-bundle-total-compare-price]')) {
               if(comparePrice > 0) {
                  submitButton.querySelector('[js-bundle-total-compare-price]').classList.remove('hidden');
                  submitButton.querySelector('[js-bundle-total-compare-price]').textContent = storeCurrency + parseFloat(comparePrice).toFixed(2);
               }
               else {
                  submitButton.querySelector('[js-bundle-total-compare-price]').classList.add('hidden');
               }
            }
          
          
        }
        getPriceUpdate()
        document.addEventListener('updateBundleTotalPrice', getPriceUpdate)
        function checkProductSelection() {
            const isAnyProductActive = bundleProducts.find(item => item.classList.contains('active'))
            if(isAnyProductActive) {
                !container.classList.contains('selected') ? container.classList.add('selected'): ""
            } else {
                container.classList.contains('selected')? container.classList.remove('selected'):""
            }
        }
    
        checkProductSelection()
        document.addEventListener('checkProductsSelection', checkProductSelection)
    
        function addToCart_() {
    
            const cart = document.querySelector('cart-drawer');
    
            const products_ = Array.from(container.querySelectorAll('input[js-product-id-input]'))
            console.log('container', container.querySelectorAll('input[js-product-id-input]'));
            const productData = []
    
            products_.map(prod => {
                if(prod.value) {
                    productData.push({
                        id: Number(prod.value),
                        quantity: 1
                    })
                }
            })
    
            submitButton.setAttribute('aria-disabled', true);
            submitButton.classList.add('loading');
            submitButton.querySelector('.loading__spinner').classList.remove('hidden');
    
            const requestBody = {
                items: productData,
            }
            console.log('requestBody', requestBody);
            requestBody.sections = cart.getSectionsToRender().map((section) => section.id);
            try {
                fetch(`${window.Shopify.routes.root}cart/add.js`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                })
                .then(resp => resp.json())
                .then(data => {
                    submitButton.querySelector('.loading__spinner').classList.add('hidden');
                    submitButton.setAttribute('aria-disabled', false);
                    submitButton.classList.remove('loading');
                   // products_.map(item=> item.value='')
                   // bundleProducts.map(prd => prd.classList.contains('active') ? prd.classList.remove('active'):"")
                    // check if any product is selected or not
                  //  document.dispatchEvent(new CustomEvent('checkProductsSelection'))
                    // update price according to product selection
                    //document.dispatchEvent(new CustomEvent('updateBundleTotalPrice'))
                    // select first bundle product
                   // document.dispatchEvent(new CustomEvent('selectFirstBundleProduct'))
                
                    cart.renderContents(data);
                    cart.querySelector('cart-drawer').open();
                })
        
            } catch(err){
              console.error({ err })
            } 
        }
    }

    pdpBundleATC()
    document.addEventListener('pdpBundleATC:init', pdpBundleATC)

})

// pdp custom products drop list
document.addEventListener('DOMContentLoaded', function() {
    const selectors= {
        container   : '[js-pdp-custom-products-drop-container]',
        header      : '[js-drop-header]',
        dropWrapper : '[js-pdp-custom-products-drop-wrapper]',
    }
    function customPDPDrop() {
    
        const container = document.querySelector(selectors.container);
        const header    = container.querySelector(selectors.header);
    
        header.addEventListener('click', function({currentTarget}) {
            const wrapper_ = currentTarget.closest(selectors.dropWrapper)
            wrapper_ && wrapper_.classList.contains('active') ? wrapper_.classList.remove('active'): wrapper_.classList.add('active')
        })
    
        // close drop on outside click
        document.addEventListener('click', function(e) {
            const dropWrapper = document.querySelector(selectors.dropWrapper)
            if(!dropWrapper.contains(e.target) || !e.target.closest(selectors.dropWrapper)) {
                dropWrapper && dropWrapper.classList.contains('active') ? dropWrapper.classList.remove('active') : "" 
            }
        })
    }
    function selectActiveOptionProductList() {
        const container = document.querySelector(selectors.container)
        const allElements = Array.from(container.querySelectorAll('pdp-custom-drop-list'))
        const activeProductHandle = container?.dataset.activeProductHandle

        const pdpDropHeader = container.querySelector('[js-drop-header]')

        if(allElements) {
            allElements.map(item => {
                if(item.dataset.productHandle == activeProductHandle) {
                    !item.classList.contains('selected') ? item.classList.add('selected') : ''
                    if(pdpDropHeader) {
                        pdpDropHeader.querySelector('[js-header-image] img').src = item.dataset.dropProductImage
                        pdpDropHeader.querySelector('[js-header-title] span').textContent = item.dataset.dropItemTitle
                        pdpDropHeader.querySelector('.image').style.backgroundColor = item.dataset.dropItemBgColor
                    }
                }
            })
        }
    }

    function pdpSubscriptionHandler() {
        const subscriptionWrapper = document.querySelector('product-info [js-pdp-custom-subscription-modal]')
        const subscriptionChecked = subscriptionWrapper?.querySelector('input[type="radio"][id="subscription"]:checked')
        const storeCurrencySymbol = subscriptionWrapper?.dataset.storeCurrency
        const pdpATCBtn = document.querySelector('[js-pdp-form-atc-button] [js-pdp-regular-price]')

        if(subscriptionChecked) {
            const originalPrice = Number(subscriptionChecked?.dataset.price)
            const percentage_   =Number(subscriptionChecked?.dataset.subscribePercent) / 100
            const totalPriceAfterDiscount = parseFloat(originalPrice - (originalPrice * percentage_)).toFixed(2)
            if(pdpATCBtn) {
             
                pdpATCBtn.textContent = storeCurrencySymbol + totalPriceAfterDiscount

            }
        } else {
            const originalPrice = Number(subscriptionWrapper?.dataset.actualPrice)
        
            if(pdpATCBtn) {
               console.log('pdpATCBtn');
                //pdpATCBtn.textContent = storeCurrencySymbol + originalPrice
            }
        }
    }

    // initialize custom products list drop , 
    selectActiveOptionProductList()
    document.addEventListener('pdpCustomDrop:reinit', selectActiveOptionProductList)

    pdpSubscriptionHandler()
    document.addEventListener('pdpSubscription:change', pdpSubscriptionHandler)

    customPDPDrop()
    document.addEventListener('customPDPDrop:init',customPDPDrop)
}) 


// custom element for pdp custom products drop down options list
class pdpCustomDropList extends HTMLElement {
    constructor() {
        super()
        this.addEventListener('click', this.handleClick)
    }

    handleClick() {
     
        this.image  = this.dataset.dropProductImage
        this.handle = this.dataset.productHandle

        // drop header item
        const container = document.querySelector('[js-pdp-custom-products-drop-container]')
        const wrapper = container.querySelector('[js-pdp-custom-products-drop-wrapper]')
        const dropHeader = container.querySelector('[js-drop-header]')
        const title = dropHeader.querySelector('[js-header-title]')
        const image = dropHeader.querySelector('[js-header-image] img')

        title.innerHTML = this.querySelector('.drop-title').innerHTML
        image.src       = this.image
        
        // remove selected class.. 
        const allSelectedItems = Array.from(document.querySelectorAll(`${this.tagName.toLowerCase()}`))
        allSelectedItems.length && allSelectedItems.map(item => item.classList.contains('selected') ? item.classList.remove('selected'):"")

        !this.classList.contains('selected') ? (this.classList.add('selected') ,wrapper && wrapper.classList.contains('active')? wrapper.classList.remove('active'):"") : ''

        // render new contents

        this.updateHistoryState(this.handle)
        this.renderSections(this.handle)
    }

    getSectionsToRender() {
        return [
            {
                selector: "js-main-product",
                sectionId: document.querySelector("[js-main-product]")?.dataset.section
            },
            {
                selector: "js-pdp-section-product-ingredients",
                sectionId: document.querySelector("[js-pdp-section-product-ingredients]")?.dataset.section
            },
            {
                selector: "js-pdp-section-product-animation",
                sectionId: document.querySelector("[js-pdp-section-product-animation]")?.dataset.section
            },
            {
                selector: "js-pdp-product-list-marquee",
                sectionId: document.querySelector("[js-pdp-product-list-marquee]")?.dataset.section
            },
            {
                selector: "js-pdp-product-ingredients",
                sectionId: document.querySelector("[js-pdp-product-ingredients]")?.dataset.section
            },
            {
                selector: "js-pdp-object-tab-list-section",
                sectionId: document.querySelector("[js-pdp-object-tab-list-section]")?.dataset.section
            },
            {
                selector: "js-pdp-review-section",
                sectionId: document.querySelector("[js-pdp-review-section]")?.dataset.section
            },
            {
                selector: "js-pdp-faq-list-section",
                sectionId: document.querySelector("[js-pdp-faq-list-section]")?.dataset.section
            },
            {
                selector: "js-pdp-product-recommendations-section",
                sectionId: document.querySelector("[js-pdp-product-recommendations-section]")?.dataset.section
            },
            {
                selector: "js-pdp-index-stock-list-section",
                sectionId: document.querySelector("[js-pdp-index-stock-list-section]")?.dataset.section
            },
            {
                selector: "js-pdp-instagram-section",
                sectionId: document.querySelector("[js-pdp-instagram-section]")?.dataset.section
            },
            {
                selector: "js-pdp-newsletter-section",
                sectionId: document.querySelector("[js-pdp-newsletter-section]")?.dataset.section
            }
           
        ]
    }
    renderSections(handle) {
        this.getSectionsToRender().forEach(section=> {

           if(section.sectionId != undefined) {
              fetch(`/products/${handle}?section_id=${section.sectionId}`)
              .then(response=>response.text())
              .then(html=>{
  
                  const doc = new DOMParser().parseFromString(html, "text/html");
                  const elementToReplace = document.querySelector(`[${section.selector}]`);
                
  
  
                  if(elementToReplace && doc.querySelector(`[${section.selector}]`)) {
                      elementToReplace.innerHTML ='';
                      elementToReplace.innerHTML = doc.querySelector(`[${section.selector}]`).innerHTML
                  }
                  if(section.selector === "js-main-product") {
                      document.dispatchEvent(new CustomEvent("initialize:pdpSubscription"))
                      document.dispatchEvent(new CustomEvent('customPDPDrop:init'))
                      document.dispatchEvent(new CustomEvent("pdpBundleATC:init"))
                      document.dispatchEvent(new CustomEvent('productMetaAccordion:init'))
                      document.dispatchEvent(new CustomEvent('pdpSubscription:change'))
                      document.dispatchEvent(new CustomEvent('pdpShippingInfo:init'))
                      document.dispatchEvent(new CustomEvent('pdpCustomDrop:reinit'))
                      document.title =  doc.querySelector(`.product__title h1`).innerText
                  }
  
                  if(section.selector === "js-pdp-section-product-animation") {
                      document.dispatchEvent(new CustomEvent("pdpAnimationSection:init"))
                  }
                  if(section.selector === "js-pdp-product-list-marquee") {
                      document.dispatchEvent(new CustomEvent("allSiteMarquee:init"))
                  }
                 
                  if(section.selector === "js-pdp-faq-list-section") {
                      document.dispatchEvent(new CustomEvent("productFaqAccordion:init"))
                  }
                  // section.selector === "js-pdp-review-section" ? (/** initialize--bv-review here*/console.log("asdf")) :"",
                  
                  if(section.selector === "js-pdp-instagram-section") {
                      document.dispatchEvent(new CustomEvent("init:pdpInstagramSectionSlider"))
                  }
                  if(section.selector === "js-pdp-product-recommendations-section") {
                      document.dispatchEvent(new CustomEvent("recommendations-slider:init"))
                  }
  
                 if(section.selector === "js-pdp-product-ingredients") {
                      document.dispatchEvent(new CustomEvent("pdpMobileIngredientsSection:init"))
                      document.dispatchEvent(new CustomEvent("pdpTabsCollectionsIngredients:init"))
                  }
                  if(section.selector === "js-pdp-object-tab-list-section") {
                      document.dispatchEvent(new CustomEvent("pdpMobileTabsSection:init"))
                      document.dispatchEvent(new CustomEvent("pdpTabsMobileTabs:init"))
                  }
                 
              }).catch(function(error) {
                  console.log(error)
              })
           }
        }
        )
    }

    updateHistoryState(handle) {
        var newurl = `${window.location.protocol}//${window.location.host}/products/${handle}`;
        window.history.pushState({
            path: newurl
        }, "", newurl)
    }
}

customElements.define('pdp-custom-drop-list', pdpCustomDropList)

